import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { DeliveryStoresStatusCSVGenerationJobService } from '@/services/StoreManagement/DeliveryStoresStatusCSVGenerationJob/DeliveryStoresStatusCSVGenerationJobService';

export const useDeliveryStoresStatusCSVGenerationJobCreate =
  async (): Promise<void> => {
    const deliveryStoresStatusCSVGenerationJobService =
      new DeliveryStoresStatusCSVGenerationJobService(getClient());
    try {
      return await deliveryStoresStatusCSVGenerationJobService.create();
    } catch (error) {
      // @ts-ignore TS18046
      if (error.status === 425) {
        // @ts-ignore TS18046
        alert(error.message);
        throw error;
      }
      // @ts-ignore TS2322
      return errorHandler({ error });
    }
  };
